import { render, staticRenderFns } from "./MyReferrals.vue?vue&type=template&id=27eca254&"
import script from "./MyReferrals.vue?vue&type=script&lang=js&"
export * from "./MyReferrals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports